<template>
    <div>
        <Table :isEmpty="localCustomFields.length === 0">
            <TableHead>
                <TableHeadCell>Internal Name</TableHeadCell>
                <TableHeadCell>Title</TableHeadCell>
                <TableHeadCell>Type</TableHeadCell>
                <TableHeadCell>Required</TableHeadCell>
                <TableHeadCell>Enabled</TableHeadCell>
                <TableHeadCell></TableHeadCell>
            </TableHead>
            <TableBody>
                <TableBodyRow
                    v-for="customField in localCustomFields"
                    :key="customField.id.value"
                >
                    <TableBodyRowCell>
                        {{ customField.internalName }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        {{ customField.title }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        <!-- TODO: Use "friendly" value here -->
                        {{ customField.type }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        <!-- TODO: Use a badge here -->
                        {{ customField.isRequired ? 'Yes' : 'No' }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        <!-- TODO: Use a badge here -->
                        {{ customField.isEnabled ? 'Yes' : 'No' }}
                    </TableBodyRowCell>
                    <TableBodyRowCell class="flex justify-end gap-1">
                        <MoveCustomFieldButton
                            :moveUp="false"
                            :customField="customField"
                            :serviceId="service.id"
                            @onSuccess="handleServiceCustomFieldUpdated($event)"
                        />
                        <MoveCustomFieldButton
                            :moveUp="true"
                            :customField="customField"
                            :serviceId="service.id"
                            @onSuccess="handleServiceCustomFieldUpdated($event)"
                        />
                        <EditCustomFieldButtonDrawer
                            :customField="customField"
                            :serviceId="service.id"
                            @onSuccess="handleServiceCustomFieldUpdated($event)"
                        />
                        <DeleteServiceCustomFieldButtonModal
                            :customField="customField"
                            :serviceId="service.id"
                            @onSuccess="
                                handleServiceCustomFieldDeleted(customField)
                            "
                        />
                    </TableBodyRowCell>
                </TableBodyRow>
            </TableBody>

            <template #emptyState>
                <TableEmptyState
                    title="No custom fields"
                    subtitle="Your service has no custom fields yet. Click the button below to create the first one."
                >
                    <template #action>
                        <CreateServiceCustomFieldButtonDrawer
                            :service="service"
                            @onSuccess="handleServiceCustomFieldCreated($event)"
                        />
                    </template>
                </TableEmptyState>
            </template>
        </Table>
        <div
            v-if="localCustomFields.length > 0"
            class="flex items-center justify-end mt-4"
        >
            <CreateServiceCustomFieldButtonDrawer
                :service="service"
                @onSuccess="handleServiceCustomFieldCreated($event)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, ref } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import CustomField from '@/App/CustomField/Entity/CustomField'

    import CreateServiceCustomFieldButtonDrawer from '@/App/Service/Component/CustomField/CreateServiceCustomFieldButtonDrawer.vue'
    import EditCustomFieldButtonDrawer from '@/App/Service/Component/CustomField/EditCustomFieldButtonDrawer.vue'
    import DeleteServiceCustomFieldButtonModal from '@/App/Service/Component/CustomField/DeleteServiceCustomFieldButtonModal.vue'
    import MoveCustomFieldButton from '@/App/Service/Component/CustomField/MoveCustomFieldButton.vue'

    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        customFields: {
            type: Object as PropType<CustomField[]>,
            required: true,
        },
    })

    const localCustomFields = ref<CustomField[]>(props.customFields)

    const handleServiceCustomFieldUpdated = (
        serviceAggregate: ServiceAggregate,
    ) => {
        localCustomFields.value = serviceAggregate.customFields
    }

    const handleServiceCustomFieldCreated = (
        serviceAggregate: ServiceAggregate,
    ) => {
        localCustomFields.value = serviceAggregate.customFields
    }

    const handleServiceCustomFieldDeleted = (
        deletedCustomField: CustomField,
    ) => {
        localCustomFields.value = localCustomFields.value.filter(
            (customField: CustomField) => {
                return customField.id.value !== deletedCustomField.id.value
            },
        )
    }
</script>
